import { cx } from '@linaria/core';
import { useRef } from 'react';
import { useElementSize } from '@utils/react';
import { usePageContext } from '../../../context.js';
import { useTaskMeta, useTaskContext } from '../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../hook.task-breakpoints.js';
import { Hints } from '../molecule.hints/_hints.js';
import { TaskIntroduction } from './_introduction.js';
import { hintsSize, introductionWrapper, stickyIntroduction, contentWrapper, content, stickyContent, splitWrapper } from './container.split-view.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function IntroductionSplitView(props) {
  const meta = useTaskMeta();
  const context = useTaskContext();
  const pageContext = usePageContext();
  const isTabletAndDown = useMatchTaskBreakpoint(taskBreakpoints.tablet.andDown());
  const isInSplitView = !isTabletAndDown && pageContext !== "print";
  const ref = useRef(null);
  const hintsRef = useRef(null);
  useElementSize(hintsRef, {
    applyTo: ref,
    axis: "vertical",
    varName: hintsSize.propName
  });
  if (!isInSplitView || !props.task.introduction.length) {
    return props.children;
  }
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: cx(splitWrapper, props.className),
    children: [/*#__PURE__*/jsx("div", {
      className: introductionWrapper,
      children: /*#__PURE__*/jsx("div", {
        className: stickyIntroduction,
        children: /*#__PURE__*/jsx(TaskIntroduction, {
          introduction: props.task.introduction
        })
      })
    }), /*#__PURE__*/jsxs("div", {
      className: contentWrapper,
      "data-content": true,
      children: [context === "input" && /*#__PURE__*/jsx("div", {
        ref: hintsRef,
        children: /*#__PURE__*/jsx(Hints, {
          taskEntryKey: meta.taskEntryKey,
          task: props.task
        })
      }), /*#__PURE__*/jsx("div", {
        className: content,
        children: /*#__PURE__*/jsx("div", {
          className: stickyContent,
          children: props.children
        })
      })]
    })]
  });
}

export { IntroductionSplitView };
//# sourceMappingURL=container.split-view.js.map
